// клиентскую “вставку” для баннеров и логгера

'use client';

import dynamic from 'next/dynamic';

import { SidebarAdItem } from '../../../components/banner/SidebarAdStack';

// Важно: пути на 1 уровень глубже, чем из layout.tsx
const Banner = dynamic(() => import('../../../components/banner/Banner'), {
  ssr: false,
  loading: () => null,
});

const BannerNew = dynamic(
  () => import('../../../components/banner/BannerNew').then((m) => m.BannerNew),
  { ssr: false, loading: () => null },
);

const ClientErrorLogger = dynamic(() => import('../../../components/ClientErrorLogger'), {
  ssr: false,
  loading: () => null,
});

export function HoroscopeSidebarAds() {
  return (
     <>
    <SidebarAdItem>
      <BannerNew />
    </SidebarAdItem>
    <SidebarAdItem>
      <Banner />
    </SidebarAdItem>
  </>
  );
}

export function HoroscopeClientTools() {
  return <ClientErrorLogger />;
}
